import { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_FACTORES_PERSONALES, ROW_COUNT, API_ADMIN_TIPO_CAUSA_BASICA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { ITipoCausaBasica } from "../../../entities/ITipoCausaBasica";
import { IFactoresPersonales } from "../../../entities/IFactoresPersonales";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";

interface IFactoresPersonalesProps {
  cbTipoCausaBasica?: Array<ITipoCausaBasica>;
  items?: Array<any>;
}

const FactoresPersonales = ({ cbTipoCausaBasica, items }: IFactoresPersonalesProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboTcb, setComboTcb] = useState<Array<ITipoCausaBasica>>(cbTipoCausaBasica || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
    };
    let result =
      items !== undefined
        ? { data: items ?? [] }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_FACTORES_PERSONALES}/getall?`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);
    setListItems(list);
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_CAUSA_BASICA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle))
      .result.data;
    setComboTcb(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }

    filter.TIPO_FACTOR = filter.ID_TIPO_FACTOR?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_FACTORES_PERSONALES}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: IFactoresPersonales, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID == "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_FACTORES_PERSONALES}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              AUTOR: "",
              AUTOR_DISPLAY: "",
              EDITOR: "",
              EDITOR_DISPLAY: "",
              ID_FACTORES: "",
              ID_TIPO_FACTOR: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_FACTOR: "",
              TITULO: "",
            },
            {}
          );
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_TIPO_FACTOR",
            value: comboTcb.map((tcb) => {
              return { text: tcb.TITULO, value: tcb.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"FactoresPersonales"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Factores Personales"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default FactoresPersonales;
